export default "__VITE_ASSET__BKojqKSA__"